import './driverList.css'
import {driverList} from "../../../../data/driversData";
import DropDown from "../../../../shared/drop-down/dropDown";

import driver1 from'../../../../assets/images/user-1.png';
import driver2 from'../../../../assets/images/user-2.png';
import driver3 from'../../../../assets/images/user-3.png';
import driver4 from'../../../../assets/images/user-4.png';
import userAvatar from'../../../../assets/images/user-5.jpeg';
import {useState} from "react";
import {NavLink} from "react-router-dom";

const DriversList = () => {
    const [drivers, setDrivers] = useState([...driverList]);
    const selectAction = (index, action) => {
        const updatedDrivers = [...drivers];
        updatedDrivers[index].action = action;
        setDrivers(updatedDrivers);
    }

    return(
        <div className={'data-table driver-list-table font-15'}>
            <ul className="table-row sf-medium light-back border-radius-8">
                <li className={'driver flex gap-20'}>
                    <div className="driver-img"></div>
                    <div className="name">Name</div>
                </li>
                <li className={'rating'}>Score</li>
                <li className={'road-safety'}>Road Safety</li>
                <li className={'cabin-safety'}>Cabin safety</li>
                <li className={'critiicalAlerts'}>Critical Alerts</li>
                <li className={'id'}>ID</li>
                <li className={'action'}>Action</li>
            </ul>
            {
                drivers.map((driver, index) =>
                    <ul key={driver.id} className="table-row border-bottom">
                        <li className={'driver flex gap-15'}>
                            <div className="user-img icon">
                                {/* {driver.img === 'user-1' && <img src={driver1} alt=""/>}
                                {driver.img === 'user-2' && <img src={driver2} alt=""/>}
                                {driver.img === 'user-3' && <img src={driver3} alt=""/>}
                                {driver.img === 'user-4' && <img src={driver4} alt=""/>} */}
                                {<img src={userAvatar} alt=""/>}
                            </div>
                            <NavLink to={`${driver.id}`} className="name highlight-color">{driver.name}</NavLink>
                        </li>
                        <li className={'rating sf-medium'}><div className="rating-box">{driver.rating}</div></li>
                        <li className={'road-safety'}><div>{driver.rating}</div></li>
                        <li className={'cabin-safety'}><div>{driver.rating}</div></li>
                        <li className={'critiicalAlerts'}>{driver.criticalAlerts}</li>
                        <li className={'id'}>{driver.id}</li>
                        <li className={`action round-corner ${driver.action ? 'green-drop-down' : ''}`}>
                            <DropDown list={['Coaching']}
                                      selected={driver.action} onItemSelect={e => selectAction(index, e)}/>
                        </li>
                    </ul>
                )
            }
        </div>
    )
}

export default DriversList;
